import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useAppSelector } from 'hooks/reduxHooks'
import { isSearchMapRedesignEligible } from 'hooks/Search/useSearchMapRedesign'
import { isBannerHiddenForPath } from 'lib/routing/routeVisibility'

import type { HideableBanner } from 'constants/routeVisibilityConfig'

export function useIsBannerHidden(banner: HideableBanner): boolean {
  const currentPath = useAppSelector(state => state.router.location.pathname)
  const { variation } = useExperiment(Experiments.searchMapRedesign, { canActivate: false })
  const isRedesignedHotelMap = variation === 'on' && isSearchMapRedesignEligible(currentPath, config.BRAND, true)

  return isBannerHiddenForPath(currentPath, banner) ||
    (isRedesignedHotelMap && (banner === 'headerTopBanners' || banner === 'notificationBanner'))
}
